import React, { useEffect, useState } from 'react';
import Icon from '../../common/Icons';

const animateValue = (from, to, progress) => Math.round(from + (to - from) * progress);

export default function PhysicianStatCard({
  title,
  value = 0,
  icon = 'chartBar',
  tone = 'teal',
  subtitle,
  hint,
  loading,
  onClick
}) {
  const [displayValue, setDisplayValue] = useState(0);
  const Tag = onClick ? 'button' : 'article';
  const interactiveClass = onClick ? ' ph-stat-card--interactive' : '';

  useEffect(() => {
    if (loading) return undefined;
    let frame = null;
    const start = performance.now();
    const from = displayValue;
    const duration = 520;

    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      setDisplayValue(animateValue(from, Number(value || 0), progress));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };

    frame = requestAnimationFrame(tick);
    return () => {
      if (frame) cancelAnimationFrame(frame);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, loading]);

  return (
    <Tag
      type={onClick ? 'button' : undefined}
      className={`ph-stat-card ph-stat-card--${tone}${interactiveClass}`}
      onClick={onClick}
    >
      <div className="ph-stat-card__head">
        <span className="ph-stat-card__title">{title}</span>
        <span className="ph-stat-card__icon" aria-hidden>
          <Icon name={icon} size={18} />
        </span>
      </div>
      <div className="ph-stat-card__value">{loading ? '—' : displayValue.toLocaleString('fr-FR')}</div>
      {hint ? <p className="ph-stat-card__sub mb-0">{hint}</p> : null}
      {subtitle && !hint ? <p className="ph-stat-card__sub mb-0">{subtitle}</p> : null}
    </Tag>
  );
}
